import { render } from "./TabsList.vue?vue&type=template&id=501992f8&scoped=true"
import script from "./TabsList.vue?vue&type=script&lang=js"
export * from "./TabsList.vue?vue&type=script&lang=js"

import "./TabsList.vue?vue&type=style&index=0&id=501992f8&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501992f8"]])

export default __exports__